<div *ngIf="showAllowModal" class="allow-audio">
    <div class="modal notification-modal">
        <div class="modal-dialog">
            <div class="modal-content container-fluid">
                <div class="modal-header">
                    <h2 class="modal-title">Ready for <span>Reading Assistant?</span></h2>
                </div>
                <div class="modal-body pt-3">
                    <div class="btn-group">
                        <button class="lets-go-button" (click)="okAudio(true)">Let's GO!</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div *ngIf="showAnimation" class="please-wait-cover"
     [ngClass]="{'soft': softAnimation}">
     <div class="white-circle"></div>
    <div *ngIf="!softAnimation" class="please-wait-animation"></div>
</div>

<div *ngIf="showAnimation && softAnimation" class="please-wait-soft-cover">
    <div class="white-circle"></div>
    <div class="please-wait-animation"></div>
</div>
